import axios from './axios'
import validator from './validator'
import moment from './moment'

function load () {
  axios.load()
  validator.load()
  moment.load()
}

export default { load }



// WEBPACK FOOTER //
// ./src/config/index.js